import dayjs from 'dayjs';

import { RelevancyCardFormat } from './types';

export const getAdditionalClasses = (itemsToShowLength: number, design: string, isPortrait: boolean): string => {
  const classes = [
    isPortrait || (design === 'mosaic-adaptive' && itemsToShowLength % 4 === 0) ? 'portrait' : '',
    itemsToShowLength % 3 === 0 ? 'mosaic-adaptive-square' : '',
    design === 'mosaic-adaptive' && itemsToShowLength % 5 === 0 && 'mosaic-adaptive-mixed',
    design === 'mosaic-adaptive' && itemsToShowLength % 7 === 0 && 'mosaic-adaptive-mixed',
  ];

  return classes.filter(Boolean).join(' ');
};
// Keep these two functions in sync, they share same logic on how to calculate the card format
export const mosaicAdaptiveFormat = (cardsNumber: number, currentCardIndex: number) => {
  if (cardsNumber <= 2) return RelevancyCardFormat.WIDE;

  if (cardsNumber % 7 === 0 && isCardIndexInRange(7, currentCardIndex, [0, 1, 2, 3]))
    return RelevancyCardFormat.PORTRAIT;

  if (cardsNumber % 4 === 0) return RelevancyCardFormat.PORTRAIT;

  if (cardsNumber % 5 === 0 && isCardIndexInRange(5, currentCardIndex, [3, 4])) return RelevancyCardFormat.WIDE;

  return null;
};
export const isNewsRecent = (newsDate: string, daysDiff = 30) =>
  newsDate && dayjs().diff(dayjs(newsDate), 'd') <= daysDiff;

/**
 * Checks if the current card index is within the range of the target indexes given the multiple number of cards per group.
 *
 * @param cardsPerGroup - The number of cards per group.
 * @param currentCardIndex - The index of the current card.
 * @param targetIndexes - The array of target indexes to check against.
 * @returns `true` if the current card index is within the range of the target indexes, `false` otherwise.
 */
export const isCardIndexInRange = (cardsPerGroup: number, currentCardIndex: number, targetIndexes: number[]) => {
  const groupNumber = currentCardIndex > 0 ? Math.trunc(currentCardIndex / cardsPerGroup) : 0;
  const indexWithinGroup = currentCardIndex - cardsPerGroup * groupNumber;
  const isInRange = targetIndexes.includes(indexWithinGroup);
  // console.log(groupNumber, indexWithinGroup, targetIndexes, isInRange);
  return isInRange;
};
